import { render, staticRenderFns } from "./LawLedesServiceList.vue?vue&type=template&id=5ece968d&"
import script from "./LawLedesServiceList.vue?vue&type=script&lang=js&"
export * from "./LawLedesServiceList.vue?vue&type=script&lang=js&"
import style0 from "./LawLedesServiceList.vue?vue&type=style&index=0&id=5ece968d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports